import { IconButton, Tooltip, Typography } from '@material-ui/core';

import moment from 'moment';
import RemoveIcon from '@material-ui/icons/Remove';
import LockIcon from '@material-ui/icons/Lock';
import CachedIcon from '@material-ui/icons/Cached';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import { HeadingTableCell } from './tableStyle';

export default function WeekDaysHeader(props) {
    const {
        index,
        tCardList,
        isToday,
        dt,
        curretDate,
        iscloseDay,
        handlePlusButtonClick,
        tCardCalendarID,
        dayfull,
        hours,
        handletSetDayFull,
        changeWeek,
        count
    } = props;

    return (
        <HeadingTableCell
            key={index}
            align="center"
            style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}
        >
            <div className={`weekdays-header-card ${isToday ? 'is-today' : ''}`} style={{ position: 'relative' }}>
                <div className={`week-top-bar ${isToday ? 'is-today' : ''}`}>
                    {/* Left arrow navigation on the first item */}
                    {index === 0 && count > 0 && (
                        <Tooltip title="Previous Week">
                            <IconButton
                                size="small"
                                style={{
                                    position: 'absolute',
                                    left: 4,
                                    backgroundColor: isToday ? 'rgba(255,255,255,0.25)' : '#ffffff',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                                    border: '1px solid #cbd5e1',
                                    padding: '1px',
                                    color: isToday ? '#ffffff' : '#1e293b',
                                    width: '18px',
                                    height: '18px'
                                }}
                                onClick={() => changeWeek('prew')}
                            >
                                <NavigateBefore style={{ fontSize: 15 }} />
                            </IconButton>
                        </Tooltip>
                    )}

                    <Typography className="week-title" style={{ color: isToday ? '#ffffff' : '#1e293b' }}>
                        WEEK {moment(dt).isoWeek()}
                    </Typography>

                    <div className="week-header-actions">
                        {/* Set / Reset Full Day */}
                        <Tooltip title={dayfull ? 'Reset Full Day' : 'Set Full Day'} aria-label="set-full-day">
                            <IconButton
                                size="small"
                                style={{
                                    backgroundColor: dayfull ? '#dc2626' : (isToday ? 'rgba(255,255,255,0.25)' : '#64748b'),
                                    color: 'white',
                                    padding: '2px',
                                    borderRadius: '4px',
                                    width: '18px',
                                    height: '18px'
                                }}
                                onClick={() => handletSetDayFull(dt, dayfull ? 'open' : 'set')}
                            >
                                {dayfull ? (
                                    <CachedIcon style={{ fontSize: '12px' }} />
                                ) : (
                                    <LockIcon style={{ fontSize: '12px' }} />
                                )}
                            </IconButton>
                        </Tooltip>

                        {/* Close Day */}
                        {moment(dt).format('YYYY-MM-DD') < moment(curretDate).format('YYYY-MM-DD') && iscloseDay && (
                            <Tooltip title="Close Day" aria-label="close-day">
                                <IconButton
                                    size="small"
                                    style={{
                                        backgroundColor: isToday ? 'rgba(255,255,255,0.25)' : '#64748b',
                                        color: 'white',
                                        padding: '2px',
                                        borderRadius: '4px',
                                        width: '18px',
                                        height: '18px'
                                    }}
                                    onClick={() => handlePlusButtonClick(tCardCalendarID)}
                                >
                                    <RemoveIcon style={{ fontSize: '12px' }} />
                                </IconButton>
                            </Tooltip>
                        )}

                        {/* Right arrow navigation on the last item */}
                        {index === tCardList.closeDays.length - 1 && (
                            <Tooltip title="Next Week">
                                <IconButton
                                    size="small"
                                    style={{
                                        backgroundColor: isToday ? 'rgba(255,255,255,0.25)' : '#ffffff',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                                        border: '1px solid #cbd5e1',
                                        padding: '1px',
                                        color: isToday ? '#ffffff' : '#1e293b',
                                        width: '18px',
                                        height: '18px',
                                        marginLeft: '2px'
                                    }}
                                    onClick={() => changeWeek('next')}
                                >
                                    <NavigateNext style={{ fontSize: 15 }} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                </div>

                <div className={`date-sub-bar ${dayfull ? 'day-full' : ''}`}>
                    {tCardList.closeDays.length > 6 ? moment(dt).format('ddd') : moment(dt).format('dddd')}
                    &nbsp; {moment(dt).format('DD-MMM-YY')}
                </div>

                <div className="metric-chip-bar">
                    <span>
                        Loan: <span className="metric-badge">{hours?.loanVehiclesBooked || '0'}</span>
                    </span>
                    <span>
                        Booked: <span className="metric-badge">{hours?.allocatedHours || 0}</span>
                        <span style={{ fontSize: '8.5px', color: '#64748b', marginLeft: '2px' }}>
                            {`(${hours?.dayAllocatedHours || 0} / ${hours?.nightAllocatedHours || 0})`}
                        </span>
                    </span>
                </div>
            </div>
        </HeadingTableCell>
    );
}
